import * as React from 'react';
import SvgIcon from '../svg-icon/SvgIcon';

export const CloseIcon = (props) => {
  return (
    <SvgIcon {...props}  viewBox="0 0 18.828 18.828" fontSize={ props.fontSize || 'small' }>
      <path d="M342,166l16-16m-16,0,16,16" transform="translate(-340.586 -148.586)"  fill="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
    </SvgIcon>
  );
};

export default CloseIcon;
